import { Link } from 'react-router-dom';

interface CTASectionProps {
  title: string;
  subtitle: string;
  primaryLabel: string;
  secondaryLabel: string;
  primaryHref: string;
  secondaryHref: string;
}

export default function CTASection({
  title,
  subtitle,
  primaryLabel,
  secondaryLabel,
  primaryHref,
  secondaryHref,
}: CTASectionProps) {
  return (
    <section className="cta-section">
      <div className="cta-section__glow" aria-hidden="true" />
      <div className="cta-section__content">
        <h2 className="cta-section__title h-2">{title}</h2>
        <p className="cta-section__subtitle body">{subtitle}</p>
        <div className="cta-section__actions">
          <Link to={primaryHref} className="btn btn--primary btn--large">
            {primaryLabel}
          </Link>
          <Link to={secondaryHref} className="btn btn--outlined btn--large">
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
